import React from "react";
import { Link } from "react-router-dom";
import "./components.css";
// import icons pack
import Ionicon from "react-ionicons";
//  image items
import Step1 from "../../assets/images/mainpage/item_1.png";
import Step2 from "../../assets/images/mainpage/item_2.png";
import Step3 from "../../assets/images/mainpage/item_2.png";

const stepList = [
  {
    title: `Does Your Product Fit the Market?`,
    description: `This tool will allow you to get real insights on how relevant is
        your product concept for the market.`,
    img: Step1,
    class:"sectionGray"
    
  },
  {
    title: `Validate the Price`,
    description: `You may have a very good product but are people willing to pay
        what you are asking to have it?`,
    img: Step2,
    class:"sectionWhite"
  },
  {
    title: `We Will Guide You All The Way Trough`,
    description: `You don’tneed to have special knowlage to use this tool and
        understand the data we provide you with.`,
    img: Step3,
    class:"sectionGray"
    
  }
];
const startButton = (
  <Link to="/register">
    <button className="buttonMid sectionButton">
      <span>START NOW IT’S FREE</span>
      <Ionicon
        icon="md-arrow-round-forward"
        fontSize="26px"
        color="#ffffff"
        className="btnIcon"
      />
    </button>
  </Link>
);
export const EasyTesting = () =>
  stepList.map((item, key) => (
    <div className={`sectionRow ${item.class}`+` ${key ===1 && "reverse"}`}>
      <div className="leftItem">
        <div className="itemHeading">{item.title}</div>
        <div className="itemDescription">
          {item.description}
          
        </div>
        {key === 2 && startButton}
      </div>
      <div className="rightItem">
        <img src={item.img} />
      </div>
    </div>
  ));

